import jsPDF from "jspdf";

export const generateLeaveApplicationPDF = (data) => {
  const doc = new jsPDF("p", "mm", "a4");

  const left = 25;
  let y = 30;
  const lineGap = 9;

  /* =========================
     TITLE
  ========================== */
  doc.setFont("Times", "Bold");
  doc.setFontSize(16);
  doc.text("LEAVE APPLICATION", 105, y, { align: "center" });

  y += 15;

  /* =========================
     TO ADDRESS
  ========================== */
  doc.setFont("Times", "Normal");
  doc.setFontSize(12);
  doc.text(
    `To,
The ${data.applying_to === "MD" ? "Managing Director" : "General Manager"}
Jharkhand Tourism Development Corporation Limited
Ranchi, Jharkhand`,
    left,
    y
  );

  y += 30;

  /* =========================
     SUBJECT
  ========================== */
  doc.setFont("Times", "Bold");
  doc.text("Subject: Application for grant of leave", left, y);

  y += lineGap * 2;

  /* =========================
     BODY
  ========================== */
  doc.setFont("Times", "Normal");

  const bodyText = `
Sir/Madam,

I respectfully submit that I, ${data.employee_name}, presently working as
${data.designation} in the ${data.department}, Jharkhand Tourism Development
Corporation Limited, request permission to avail ${data.leave_type} leave for
${data.total_days} day(s) from ${data.leave_from} to ${data.leave_to} on account of
${data.reason}.

I assure that my official duties shall be managed appropriately and I shall
resume duties immediately after the expiry of the sanctioned leave period.

I therefore request you to kindly grant the leave for the period mentioned above.

Attachment: ${data.attachment ? "Enclosed" : "NIL"}
`;

  doc.text(bodyText.trim(), left, y, {
    maxWidth: 160,
    lineHeightFactor: 1.6,
  });

  /* =========================
     EMPLOYEE SIGNATURE
  ========================== */
  doc.text(
    `Date: ${data.applied_date}`,
    left,
    235
  );

  doc.text(
    `${data.employee_name}`,
    140,
    225
  );

  doc.setFont("Times", "Italic");
  doc.setFontSize(10);
  doc.text(
    `(Applied for leave via the JTDCL portal)`,
    140,
    233,
    { align: "center" }
  );

  /* =========================
     AUTHORITY SIGNATURE BLOCK
  ========================== */

  doc.setFont("Times", "Normal");
  doc.setFontSize(12);
  doc.text(
    `Signature of ${data.applying_to === "MD" ? "Managing Director" : "General Manager"}`,
    left,
    275
  );

  doc.text(
    `_______________________________`,
    left,
    281
  );

  /* =========================
     SAVE
  ========================== */
  doc.save(`${data.employee_name}_Leave_Application_${data.applied_date}.pdf`);
};
